import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

export const organizationSeatsGuard = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  if (store.isOnlyLearner || store.isOrgIndividual || store.isInternalAdmin) {
    router.push({ name: "PageRestricted" });
    return;
  }

  return next();
};
